import { Avatar, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { BlueDocReceived, PurplePaperPlane } from 'Images';

interface IDocumentReceivedOrSent {
  isSentToUser: boolean;
}

export const DocumentReceivedOrSent = ({
  isSentToUser,
}: IDocumentReceivedOrSent) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Documents);

  return (
    <Stack
      direction='row'
      alignItems='center'
      gap='8px'
      sx={{
        width: 'fit-content',
      }}
    >
      <Avatar
        alt=''
        src={isSentToUser ? BlueDocReceived : PurplePaperPlane}
        sx={{
          width: '24px',
          height: '24px',
        }}
      />
      <Typography variant='body6' whiteSpace='nowrap'>
        {isSentToUser ? dictionary.receivedDoc : dictionary.sentDoc}
      </Typography>
    </Stack>
  );
};
